import React, { HTMLAttributes } from 'react';
import { Cell, Box } from '@wix/design-system';

interface LeftSectionLayoutProps extends HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  sectionId: string;
}

const LeftSectionLayout = React.forwardRef(
  (props: LeftSectionLayoutProps, ref: any) => {
    const { children, sectionId } = props;
    return (
      <Cell span={8}>
        <Box maxWidth="717px">
          <section
            style={{ width: '100%' }}
            id={sectionId}
            tabIndex={-1}
            ref={(el) => {
              if (ref?.current) {
                ref.current[sectionId] = el;
              }
            }}
          >
            {children}
          </section>
        </Box>
      </Cell>
    );
  },
);

export default LeftSectionLayout;
